import { MediaQueries } from 'UI/'

export default {
  card2: {
  },
  card1: {
  },
  card3: {
  },
  cardsContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    margin: ({ margin }) => margin || 0
  },
  [`${MediaQueries.tablet}`]: {
    card1: {
      paddingRight: 0,
      minHeight: 'auto',
      marginBottom: 16
    },
    card2: {
      paddingLeft: 0,
      height: 'auto'
    },
    card3: {
      paddingRight: 0,
      height: 'auto',
      marginBottom: 16
    }
  },
  [`${MediaQueries.mobile}`]: {
    card1: {
      paddingRight: 0,
      minHeight: 'auto',
      marginBottom: 16
    },
    card2: {
      paddingLeft: 0,
      height: 'auto'
    },
    card3: {
      paddingRight: 0,
      height: 'auto',
      marginBottom: 16
    }
  }
}
